export const BASE_URL: string = process.env.REACT_APP_API_KEY || '';
// export const BASE_URL: string = 'http://178.128.61.122:8081';
// const ROLE: string = 'http://178.128.61.122:8092';
// export const PROFILE_URL: string = 'http://178.128.61.122:8085';

export const EMPLOYEE_FIND_MANY: string = BASE_URL + '/admin/findAll';
export const EMPLOYEE_CREATE: string = BASE_URL + '/admin/register';
export const EMPLOYEE_UPDATE: string = BASE_URL + '/admin/update?id=';
export const EMPLOYEE_DELETE: string = BASE_URL + '/admin/delete?id=';

//role admin
export const FIND_ROLE_AND_PERMISSION = BASE_URL + '/rolePermission/role/findMany';

//officer profile 
export const OFFICER_PROFILE_FIND_MANY = BASE_URL + '/profile/officer-profile/find-many';
export const OFFICER_PROFILE_UPDATE = BASE_URL + '/profile/officer-profile/update?Id=';
export const OFFICER_PROFILE_DELETE = BASE_URL + '/profile/officer-profile/delete?Id=';